/* istanbul ignore file */

import { GridRendererFormattingData } from './grid-renderer-formatting-data';

export class GridRendererServiceModel {
    siteGridsFormattingMap = new Map<string, Map<string, GridRendererFormattingData>>();
}
